import Flex from '@Components/Bases/Flex';
import FormCheckbox from '@Components/Form/FormCheckBox';
import { Box, Divider, Typography } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import {
  checkOtherDescriptionEnValid,
  checkOtherDescriptionThValid,
  checkOverviewEnValid,
  checkOverviewThValid,
  isEsgScoreComplete,
} from './utils';
import { formatToShortThaiDateTime } from '@Utils/datetime';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { resetCompletedSection } from '@Utils/updateCompletedSection';

const EsgPlatFormCheckComplete = () => {
  const { control, setValue } = useFormContext();
  const { isPublished } = useProgressBar();
  const [esgDataPlatform, esgStatus, otherDescriptions] = useWatch({
    control,
    name: ['esgDataPlatform', 'esgStatus', 'otherDescriptions'],
  });

  const completedSection =
    (useWatch({
      name: 'completedSection',
    }) as CompleteSectionFormValues) || {};

  const {
    isCompletedTh,
    isCompletedEn,
    dateTh,
    dateEn,
    roleStampTh,
    roleStampEn,
  } = completedSection;

  const esgScoreTh = esgStatus?.percentageTh;

  const formattedCompletedSectionDateTh = dateTh
    ? formatToShortThaiDateTime(dateTh)
    : '';
  const formattedCompletedSectionDateEn = dateEn
    ? formatToShortThaiDateTime(dateEn)
    : '';

  const isEsgScorePassTh = isEsgScoreComplete(esgScoreTh);

  const isOverviewThValid = esgDataPlatform
    ? checkOverviewThValid(esgDataPlatform)
    : true;
  const isOverviewEnValid = esgDataPlatform
    ? checkOverviewEnValid(esgDataPlatform)
    : true;

  const isOtherDescriptionEnValid = otherDescriptions
    ? checkOtherDescriptionEnValid(otherDescriptions)
    : true;

  const isOtherDescriptionThValid = otherDescriptions
    ? checkOtherDescriptionThValid(otherDescriptions)
    : true;

  const handleCheckboxChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    language: 'Th' | 'En'
  ) => {
    const updatedSection = { ...completedSection };

    if (language === 'Th') {
      updatedSection.isCompletedTh = e.target.checked;
    } else {
      updatedSection.isCompletedEn = e.target.checked;
    }

    resetCompletedSection(updatedSection, setValue);
  };

  return (
    <Box bgcolor={'common.white'}>
      <Typography fontWeight={800} p={2}>
        กรณีต้องการยืนยันความถูกต้อง
      </Typography>
      <Divider />
      <Flex gap={4} justifyContent={'center'} bgcolor={'grey.50'} py={1}>
        <Flex alignItems={'center'}>
          <Typography fontWeight="bold" textAlign={'right'}>
            ส่วนการยืนยันการตรวจสอบข้อมูลครบถ้วน
          </Typography>
        </Flex>
        <Flex flexDirection="column" alignItems={'center'}>
          <FormCheckbox
            name="completedSection.isCompletedTh"
            label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาไทย)"
            inputProps={{
              disabled:
                isPublished ||
                !isOverviewThValid ||
                !isEsgScorePassTh ||
                !isOtherDescriptionThValid,
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleCheckboxChange(e, 'Th')
            }
          />
          {isCompletedTh && dateTh && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ display: 'block' }}
            >
              โดย {roleStampTh} {formattedCompletedSectionDateTh}
            </Typography>
          )}
        </Flex>
        <Flex flexDirection="column" alignItems={'center'}>
          <FormCheckbox
            sx={{ ml: 2 }}
            name="completedSection.isCompletedEn"
            label="จัดเตรียมข้อมูลเรียบร้อย (ภาษาอังกฤษ)"
            inputProps={{
              disabled:
                isPublished ||
                !isOverviewEnValid ||
                !isOtherDescriptionEnValid ||
                !isEsgScorePassTh,
            }}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleCheckboxChange(e, 'En')
            }
          />
          {isCompletedEn && dateEn && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ display: 'block' }}
            >
              โดย {roleStampEn} {formattedCompletedSectionDateEn}
            </Typography>
          )}
        </Flex>
      </Flex>
    </Box>
  );
};

export default EsgPlatFormCheckComplete;
